import React from "react";

import { cn } from "@/lib/utils";
import MMLogo from "@/shared/components/MMLogo";
import { Card, CardContent } from "@/shared/components/ui/card";

type CardProps = React.ComponentProps<typeof Card>;
type AuthPageProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
  cardProps?: CardProps;
  contentClassName?: string;
};

export default function AuthPage({ title, children, className, cardProps, contentClassName }: AuthPageProps) {
  return (
    <div
      className={cn(
        "container mx-auto flex min-h-dvh w-full max-w-lg flex-col items-center gap-8 px-4 py-16",
        className,
      )}
    >
      <a href="https://monetary-metals.com/" target="_blank" rel="noreferrer" aria-label="Monetary Metals">
        <MMLogo className="max-w-lg" />
      </a>
      <Card className={cn("w-full", cardProps?.className)} {...cardProps}>
        <CardContent className={cn("p-8", contentClassName)}>
          {title && <h1 className="mb-8 text-center text-2xl font-bold">{title}</h1>}
          {children}
        </CardContent>
      </Card>
    </div>
  );
}
